import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, Navigate } from 'react-router-dom';
import { AdsGETApiWithToken, AdsPOSTApi, AdsPOSTApiWithoutAuth, AdsPOSTApiWithToken, AdsPUTApi, AdsPUTApiToken, MainTitle, signInImage, UserMe, userSignIn } from '../Constant/api';
import { slugs } from '../Constant/slugs';
import { login } from '../redux/action';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
// import ForgetPasswordComponent from './ForgetPassword';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

export default function OnlineLoginScreen() {
  const [userName, setUserName] = React.useState("")
  const [password, setPassword] = React.useState("")
  const [confirmPassword, setConfirmPassword] = React.useState("")
  const [email, setEmail] = React.useState("")
  const [PhoneNumber, setPhoneNumer] = React.useState("")

  const [reload, setReload] = React.useState(false)
  const [passwordShow, setPasswordShow] = React.useState(false)
  const [AlertShow, setAlertShow] = React.useState(false)
  const [Alertcomp, setAlertcomp] = React.useState("")
  const [Register, setRegister] = React.useState(false)
  const [loginSuccess, setLoginSuccess] = React.useState(false)
  const [forgetPasswordPressed, setForgetPasswordPressed] = React.useState(false)
  const history = useHistory()
  const dispatch = useDispatch()
  const getDeviceFingerprint = async () => {
    const fp = await FingerprintJS.load();
    const result = await fp.get();

    // console.log(result.visitorId)
    // console.log(result.deviceFingerprint)

    return result.visitorId; // unique & stable
  };
  const UserInfo = () => {
    setReload(true)
    UserMe(window.btoa(`${userName}:${password}`))
      .then((res) => {
        AdsGETApiWithToken(
          {
            _fields: "id,meta.batch_id,meta.user_profile_picture,meta.user_phone_number,meta.device_id",
            status: "any",
            "filter[meta_query][1][key]": "user_id",
            "filter[meta_query][1][value][0]": `${res.data.id}`,
            "filter[meta_query][1][compare]": "=",
          },
          slugs.db_slug_user_data, window.btoa(`${userName}:${password}`))
          .then((response) => {
            if (response.data.length == 1) {
              var deviceid = response.data[0].meta.device_id
              var id = ""
              getDeviceFingerprint().then(fingerprint => {
                if (deviceid == fingerprint) {
                  dispatch(login(
                    `${res.data.id}`,
                    `${res.data.name}`,
                    `${window.btoa(`${userName}:${password}`)}`,
                    `${res.data.user_email}`,
                    `${res.data.roles[0]}`,
                    `${response.data[0].meta.user_profile_picture}`,
                    `${response.data[0].meta.user_phone_number}`,
                    `${response.data[0].meta.batch_id}`,
                  ))
                  history.push('/')

                }
                else if (deviceid == "") {
                  AdsPUTApiToken(
                    { meta: { device_id: `${fingerprint}` } },
                    slugs.db_slug_user_data,
                    response.data[0].id,
                    window.btoa(`${userName}:${password}`)
                  )
                    .then((response2) => {
                      dispatch(login(
                        `${res.data.id}`,
                        `${res.data.name}`,
                        `${window.btoa(`${userName}:${password}`)}`,
                        `${res.data.user_email}`,
                        `${res.data.roles[0]}`,
                        `${response.data[0].meta.user_profile_picture}`,
                        `${response.data[0].meta.user_phone_number}`,
                        `${response.data[0].meta.batch_id}`,
                      ))
                      history.push('/')
                    }).catch(e => {
                      console.log(e)
                    })
                }
                else {
                  setAlertShow(true)
                  setAlertcomp("User is logged in in other phone or other browser")
                }

              })


              // history.push('/')
            }
            else {
              setAlertShow(true)
              setAlertcomp("User Not Found")
            }
          })
        setLoginSuccess(true)
      }).catch((err) => {
        console.warn(err);
        console.warn(err.response.data);
        console.log("Response Status:", err.response.status);
        console.log("Response Headers:", err.response.headers);
      }).finally(() =>
        setReload(false)
      )
  }

  const AlertComponent = () => {
    return (
      <div className="modal"
        onClick={() => {
          setAlertShow(false)
        }}
      >
        <div>
          <div className="row " style={{ minHeight: "10vh", marginTop: "10vh" }}>
            <div className="col-lg-4 col-1"></div>
            <div className="col-lg-4 col-10 pb-5  bg-white  shadow">
              <div className="p-5">
                <div dangerouslySetInnerHTML={{ __html: Alertcomp }}></div>
              </div>
              <div style={{ display: 'flex', cursor: 'pointer' }} className="center">
                <div className="sign-in-button-1 col-8">
                  OK
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
  return (
    <div style={{ backgroundColor: "#f2f3f2", minHeight: "100vh", width: "100vw", overflow: 'hidden' }}>
      <div className="row">
        {/* {loginSuccess &&
          <Navigate to="/" />
        } */}
        <div className="col-lg-2 col-1"></div>
        <div className="col-lg-8 col-10 shadow signin-container" style={{ backgroundColor: "#fff" }}>
          <div className="py-5">
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <img
                src={signInImage}
                height={"100px"}
              />
            </div>
            <>
              <div className={"font-size-24"} style={{ textAlign: 'center', fontWeight: "bold" }}>
                Log in to {MainTitle}

              </div>
              <div className="center">
                Enter your registered phone number and your roll number to login.<br />
                You can login as online student in only one device.<br />
                In case your device is changed please contact admin.
              </div>
            </>
            <div className="row">
              <div className="col-lg-3 col-1" />
              <div className="col-lg-6 col-10 px-5">

                <div className="label-form">Roll Number.</div>
                <input
                  className="col-12  input-style"
                  type="text"
                  value={userName}
                  onChange={(event) => { setUserName(event.target.value) }}
                  placeholder="Enter your Roll Number"
                  required
                /><br />
                <div className="label-form">Phone Number.</div>
                <input
                  className="col-12  input-style"
                  type={passwordShow ? "text" : "password"}
                  value={password}
                  onChange={(event) => { setPassword(event.target.value) }}
                  placeholder="Enter your registered Phone Number"
                  required
                /><br />



                <div className="center">
                  <button onClick={() => {
                    UserInfo()
                  }} className="sign-in-button-1 col-8">
                    Sign In
                  </button>
                  <br />

                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      {reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }
      {AlertShow &&
        <AlertComponent />
      }
    </div>
  )
}